import ServicesGrid from "../../ServicesPage/components/ServicesGrid";
import WhyChooseUs from "../../HomePage/components/WhyChooseUs";
import Reviews from "../../HomePage/components/Reviews";
import FAQs from "../../HomePage/components/FAQs";
import BurgerMenu from "../../../reusableUi/BurgerMenu";
import { Link, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import PrimaryButton from "../../../reusableUi/PrimaryButton";
import { useState, useEffect, useRef } from "react";
import Footer from "../../../reusableUi/Footer";
import DropDownBar from "../../../reusableUi/DropDownBar";
import { Wrench, Phone, ArrowLeft, Mail } from "lucide-react";
import CTASection from "../../../reusableUi/CTA";

const data = [
  {
    title: "Lincoln Park",
    description:
      "We provide fast and reliable plumbing services throughout Lincoln Park for apartments, homes, and older buildings in the area.",
    slug: "lincoln-park",
    coords: { lat: 41.9214, lng: -87.6513 },
    metaDesc:
      "Licensed plumbers in Lincoln Park Chicago. Fast emergency plumbing, drain cleaning, leak repair, and water heater service.",
    benefits: [
      {
        title: "Fast Local Service",
        desc: "Rapid response across the neighborhood to minimize plumbing downtime and prevent damage.",
      },
      {
        title: "Older Pipe Experience",
        desc: "Experienced in handling aging plumbing systems common in historic buildings.",
      },
      {
        title: "Licensed Professionals",
        desc: "Certified plumbers who follow local codes and safety standards.",
      },
      {
        title: "Clear Pricing",
        desc: "Upfront estimates with transparent costs before any work begins.",
      },
    ],
    reviews: [
      {
        text: "Quick service and very professional work.",
        name: "Alex, Lincoln Park",
        job: "Homeowner",
        rating: 5,
      },
      {
        text: "Arrived fast and fixed everything.",
        name: "Sarah, Lincoln Park",
        job: "Tenant",
        rating: 4,
      },
      {
        text: "Very reliable local plumbers.",
        name: "John, Lincoln Park",
        job: "Landlord",
        rating: 5,
      },
      {
        text: "Great service from start to finish.",
        name: "Michael, Lincoln Park",
        job: "Homeowner",
        rating: 5,
      },
    ],
    faqs: [
      {
        question: "Do you provide plumbing services throughout Lincoln Park?",
        answer:
          "Yes. We serve all residential and commercial properties across Lincoln Park with fast response and professional plumbing solutions.",
      },
      {
        question: "Are you familiar with older plumbing systems in this area?",
        answer:
          "Yes. Many buildings in Lincoln Park have older pipe systems and we have experience repairing and maintaining them safely.",
      },
      {
        question: "Do you offer emergency plumbing in Lincoln Park?",
        answer:
          "Yes. Our team is available for emergency plumbing services day and night throughout the neighborhood.",
      },
    ],
  },

  {
    title: "Wicker Park",
    description:
      "We deliver professional plumbing services across Wicker Park for apartments, condos, and residential properties.",
    slug: "wicker-park",
    coords: { lat: 41.9088, lng: -87.6796 },
    metaDesc:
      "Licensed plumbers in Wicker Park Chicago. Fast emergency plumbing, drain cleaning, leak repair, and water heater service.",
    benefits: [
      {
        title: "Quick Local Service",
        desc: "Fast response times throughout Wicker Park for urgent plumbing issues.",
      },
      {
        title: "Residential Expertise",
        desc: "Experienced with apartments, condos, and single-family homes.",
      },
      {
        title: "Experienced Plumbers",
        desc: "Skilled professionals handling repairs, replacements, and maintenance.",
      },
      {
        title: "Reliable Work",
        desc: "Focused on long-term plumbing solutions, not temporary fixes.",
      },
    ],
    reviews: [
      {
        text: "Fast response and great service.",
        name: "Maya, Wicker Park",
        job: "Tenant",
        rating: 4,
      },
      {
        text: "Very clean and professional work.",
        name: "Omar, Wicker Park",
        job: "Homeowner",
        rating: 5,
      },
      {
        text: "Solved the issue quickly.",
        name: "Leah, Wicker Park",
        job: "Manager",
        rating: 5,
      },
      {
        text: "Friendly and reliable plumbers.",
        name: "Daniel, Wicker Park",
        job: "Homeowner",
        rating: 4,
      },
    ],
    faqs: [
      {
        question: "Do you serve all of Wicker Park?",
        answer:
          "Yes. We provide plumbing services throughout Wicker Park and surrounding residential areas.",
      },
      {
        question: "Do you work in apartments and condos?",
        answer:
          "Yes. We regularly service apartments, condos, and single-family homes in the neighborhood.",
      },
      {
        question: "Can you respond quickly to plumbing emergencies?",
        answer:
          "Yes. Our local team is able to respond fast to emergency plumbing calls in Wicker Park.",
      },
    ],
  },

  {
    title: "Lakeview",
    description:
      "We offer dependable plumbing services in Lakeview for homes, apartments, and multi-unit properties.",
    slug: "lakeview",
    coords: { lat: 41.9415, lng: -87.6536 },
    metaDesc:
      "Licensed plumbers in Lakeview Chicago. Fast emergency plumbing, drain cleaning, leak repair, and water heater service.",
    benefits: [
      {
        title: "Fast Local Service",
        desc: "Prompt scheduling and quick arrival across Lakeview.",
      },
      {
        title: "Multi-Unit Experience",
        desc: "Comfortable working in apartment and condo buildings.",
      },
      {
        title: "Licensed Professionals",
        desc: "Work performed by certified and trained plumbers.",
      },
      {
        title: "Reliable Repairs",
        desc: "Durable repairs designed to prevent repeat issues.",
      },
    ],
    reviews: [
      {
        text: "Very fast and professional.",
        name: "Aisha, Lakeview",
        job: "Homeowner",
        rating: 5,
      },
      {
        text: "Fixed everything in one visit.",
        name: "Daniel, Lakeview",
        job: "Tenant",
        rating: 4,
      },
      {
        text: "Great local service.",
        name: "Fatima, Lakeview",
        job: "Homeowner",
        rating: 5,
      },
      {
        text: "Highly recommend them.",
        name: "Thomas, Lakeview",
        job: "Homeowner",
        rating: 5,
      },
    ],
    faqs: [
      {
        question: "Do you provide plumbing services across Lakeview?",
        answer:
          "Yes. We serve all residential and commercial properties throughout Lakeview.",
      },
      {
        question: "Are you experienced with multi-unit buildings?",
        answer:
          "Yes. Many Lakeview properties are multi-unit buildings and we regularly work on these systems.",
      },
      {
        question: "Do you offer emergency plumbing services here?",
        answer:
          "Yes. Emergency plumbing services are available throughout Lakeview at all times.",
      },
    ],
  },

  {
    title: "Logan Square",
    description:
      "We deliver fast plumbing services across Logan Square for residential and multi-unit properties.",
    slug: "logan-square",
    coords: { lat: 41.9231, lng: -87.7093 },
    metaDesc:
      "Licensed plumbers in Logan Square Chicago. Fast emergency plumbing, drain cleaning, leak repair, and water heater service.",
    benefits: [
      {
        title: "Quick Local Service",
        desc: "Fast arrival times across Logan Square.",
      },
      {
        title: "Home & Apartment Expertise",
        desc: "Experienced with houses and rental properties.",
      },
      {
        title: "Licensed Professionals",
        desc: "Work completed by trained and certified plumbers.",
      },
      {
        title: "Reliable Workmanship",
        desc: "Long-lasting plumbing repairs and installations.",
      },
    ],
    reviews: [
      {
        text: "Fast response and great service.",
        name: "Grace, Logan Square",
        job: "Homeowner",
        rating: 5,
      },
      {
        text: "Very reliable local plumbers.",
        name: "Omar, Logan Square",
        job: "Landlord",
        rating: 5,
      },
      {
        text: "Fixed everything quickly.",
        name: "Leila, Logan Square",
        job: "Tenant",
        rating: 4,
      },
      {
        text: "Great workmanship overall.",
        name: "Brian, Logan Square",
        job: "Homeowner",
        rating: 5,
      },
    ],
    faqs: [
      {
        question: "Do you provide plumbing services in Logan Square?",
        answer:
          "Yes. We serve all residential and commercial properties in Logan Square.",
      },
      {
        question: "Do you handle apartments and houses here?",
        answer:
          "Yes. We regularly work with both apartments and single-family homes.",
      },
      {
        question: "Can you respond quickly to emergencies?",
        answer:
          "Yes. Our team responds fast to emergency plumbing calls in Logan Square.",
      },
    ],
  },

  {
    title: "River North",
    description:
      "We provide professional plumbing services in River North for condos, apartments, and commercial properties.",
    slug: "river-north",
    coords: { lat: 41.8924, lng: -87.6343 },
    metaDesc:
      "Licensed plumbers in River North Chicago. Fast emergency plumbing, drain cleaning, leak repair, and water heater service.",
    benefits: [
      {
        title: "Fast City Response",
        desc: "Rapid response throughout downtown locations.",
      },
      {
        title: "Condo & High-Rise Experience",
        desc: "Experienced working in high-rise and shared plumbing systems.",
      },
      {
        title: "Licensed Plumbers",
        desc: "Certified professionals following city building codes.",
      },
      {
        title: "Upfront Pricing",
        desc: "Clear, honest pricing before work begins.",
      },
    ],
    reviews: [
      {
        text: "Very professional downtown service.",
        name: "Nora, River North",
        job: "Tenant",
        rating: 5,
      },
      {
        text: "Fast and reliable plumbers.",
        name: "Imran, River North",
        job: "Homeowner",
        rating: 5,
      },
      {
        text: "Handled everything smoothly.",
        name: "Samantha, River North",
        job: "Manager",
        rating: 4,
      },
      {
        text: "Great work in our condo.",
        name: "David, River North",
        job: "Homeowner",
        rating: 5,
      },
    ],
    faqs: [
      {
        question: "Do you work in high-rise buildings in River North?",
        answer:
          "Yes. We regularly service condos and high-rise properties in River North.",
      },
      {
        question: "Are emergency services available downtown?",
        answer:
          "Yes. We provide emergency plumbing services throughout River North.",
      },
      {
        question: "Do you service commercial properties here?",
        answer:
          "Yes. We work with both residential and commercial buildings in the area.",
      },
    ],
  },

  {
    title: "South Loop",
    description:
      "We offer reliable plumbing services in South Loop for apartments, condos, and residential properties.",
    slug: "south-loop",
    coords: { lat: 41.8756, lng: -87.6244 },
    metaDesc:
      "Licensed plumbers in South Loop Chicago. Fast emergency plumbing, drain cleaning, leak repair, and water heater service.",
    benefits: [
      {
        title: "Fast Local Service",
        desc: "Quick arrival for urgent plumbing needs.",
      },
      {
        title: "Building Experience",
        desc: "Experienced with condo and apartment plumbing systems.",
      },
      {
        title: "Licensed Professionals",
        desc: "Certified plumbers meeting all code requirements.",
      },
      {
        title: "Reliable Repairs",
        desc: "Long-term plumbing solutions you can depend on.",
      },
    ],
    reviews: [
      {
        text: "Quick and professional service.",
        name: "Grace, South Loop",
        job: "Homeowner",
        rating: 5,
      },
      {
        text: "Very clean work.",
        name: "Omar, South Loop",
        job: "Tenant",
        rating: 5,
      },
      {
        text: "Solved our plumbing issues fast.",
        name: "Leila, South Loop",
        job: "Manager",
        rating: 4,
      },
      {
        text: "Great experience overall.",
        name: "Brian, South Loop",
        job: "Homeowner",
        rating: 5,
      },
    ],
    faqs: [
      {
        question: "Do you serve all of South Loop?",
        answer:
          "Yes. We provide plumbing services throughout South Loop and nearby areas.",
      },
      {
        question: "Do you work in condo buildings here?",
        answer:
          "Yes. Many South Loop properties are condos and apartments we regularly service.",
      },
      {
        question: "Is emergency plumbing available in South Loop?",
        answer:
          "Yes. Emergency plumbing services are available at all times in South Loop.",
      },
    ],
  },

  {
    title: "Old Town",
    description:
      "We deliver dependable plumbing services in Old Town for residential homes and apartment buildings.",
    slug: "old-town",
    coords: { lat: 41.9118, lng: -87.634 },
    metaDesc:
      "Licensed plumbers in Old Town Chicago. Fast emergency plumbing, drain cleaning, leak repair, and water heater service.",
    benefits: [
      {
        title: "Fast Local Service",
        desc: "Quick response times throughout Old Town.",
      },
      {
        title: "Older Pipe Experience",
        desc: "Skilled in repairing aging plumbing systems.",
      },
      {
        title: "Licensed Plumbers",
        desc: "Certified professionals ensuring code-compliant work.",
      },
      {
        title: "Clear Pricing",
        desc: "Transparent estimates before starting any job.",
      },
    ],
    reviews: [
      {
        text: "Very fast and professional.",
        name: "Alex, Old Town",
        job: "Homeowner",
        rating: 5,
      },
      {
        text: "Great local service.",
        name: "Sarah, Old Town",
        job: "Tenant",
        rating: 4,
      },
      {
        text: "Fixed everything quickly.",
        name: "John, Old Town",
        job: "Landlord",
        rating: 5,
      },
      {
        text: "Highly recommend them.",
        name: "Michael, Old Town",
        job: "Homeowner",
        rating: 5,
      },
    ],
    faqs: [
      {
        question: "Do you provide plumbing services throughout Old Town?",
        answer: "Yes. We serve homes and apartment buildings across Old Town.",
      },
      {
        question: "Are you familiar with older plumbing systems here?",
        answer:
          "Yes. Many Old Town properties have older pipes that require experienced service.",
      },
      {
        question: "Do you offer emergency plumbing services?",
        answer:
          "Yes. Emergency plumbing services are available throughout Old Town.",
      },
    ],
  },

  {
    title: "Gold Coast",
    description:
      "We provide high-quality plumbing services in Gold Coast for condos, apartments, and residential properties.",
    slug: "gold-coast",
    coords: { lat: 41.9058, lng: -87.6243 },
    metaDesc:
      "Licensed plumbers in Gold Coast Chicago. Fast emergency plumbing, drain cleaning, leak repair, and water heater service.",
    benefits: [
      {
        title: "Fast City Response",
        desc: "Rapid service across Gold Coast and nearby areas.",
      },
      {
        title: "Condo Experience",
        desc: "Experienced with shared plumbing systems in condo buildings.",
      },
      {
        title: "Licensed Professionals",
        desc: "Certified plumbers ensuring safe and compliant work.",
      },
      {
        title: "Upfront Pricing",
        desc: "Honest pricing with no hidden fees.",
      },
    ],
    reviews: [
      {
        text: "Very professional service.",
        name: "Maya, Gold Coast",
        job: "Tenant",
        rating: 5,
      },
      {
        text: "Fast and reliable plumbers.",
        name: "Omar, Gold Coast",
        job: "Homeowner",
        rating: 5,
      },
      {
        text: "Handled everything smoothly.",
        name: "Leah, Gold Coast",
        job: "Manager",
        rating: 4,
      },
      {
        text: "Great experience overall.",
        name: "Daniel, Gold Coast",
        job: "Homeowner",
        rating: 5,
      },
    ],
    faqs: [
      {
        question: "Do you work in condos and apartments in Gold Coast?",
        answer:
          "Yes. We regularly service condo buildings and residential properties in Gold Coast.",
      },
      {
        question: "Is emergency plumbing available here?",
        answer:
          "Yes. Emergency plumbing services are available throughout Gold Coast.",
      },
      {
        question: "Do you service high-rise buildings?",
        answer:
          "Yes. We work with high-rise and multi-unit properties in the area.",
      },
    ],
  },
];

export default function ServicesInfo() {
  const { slug } = useParams();
  const service = data.find((item) => item.slug === slug);
  const navigate = useNavigate();

  useEffect(() => {
    if (!service) return;
    document.title = `Plumbing Services in ${service.title}, Chicago | Local Plumber`;
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", service.metaDesc);
  }, [service]);

  const upSection = useRef(null);
  const goBack = () => (window.history.length > 1 ? navigate(-1) : navigate("/"));

  return (
    <div className="space-y-26">
      <header className="max-w-[90%] mx-auto xl:max-w-6xl">

        {/* Mobile nav */}
        <nav className="md:hidden flex items-center justify-between py-5 mb-4">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-md shadow-blue-600/30">
              <Wrench className="w-4 h-4 text-white" />
            </span>
            <span className="text-xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
          </Link>
          <BurgerMenu />
        </nav>

        {/* Tablet nav */}
        <nav className="hidden max-lg:md:flex items-center justify-between py-5 mb-6">
          <Link to="/" className="flex items-center gap-2.5">
            <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-md shadow-blue-600/30">
              <Wrench className="w-4 h-4 text-white" />
            </span>
            <span className="text-xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
          </Link>
          <ul className="flex items-center gap-8">
            <li>
              <button onClick={goBack} className="flex items-center gap-1.5 font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">
                <ArrowLeft className="w-4 h-4" /> Go Back
              </button>
            </li>
            <li>
              <a href="#faqs" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">FAQs</a>
            </li>
            <li>
              <a href="#footer" className="text-sm font-bold bg-blue-600 hover:bg-blue-700 transition-colors px-5 py-2.5 text-white rounded-xl shadow-md shadow-blue-600/25">
                Contact Us
              </a>
            </li>
          </ul>
        </nav>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center justify-between py-6 mb-12">
          <Link to="/" className="flex items-center gap-3">
            <span className="w-9 h-9 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-600/30">
              <Wrench className="w-4 h-4 text-white" />
            </span>
            <span className="text-2xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
          </Link>
          <ul className="flex items-center gap-10">
            <li>
              <button onClick={goBack} className="flex items-center gap-1.5 font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">
                <ArrowLeft className="w-4 h-4" /> Go Back
              </button>
            </li>
            <li>
              <Link to="/services" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">All Services</Link>
            </li>
            <li>
              <a href="#faqs" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">FAQs</a>
            </li>
            <li>
              <a href="#footer" className="flex items-center gap-2 font-bold bg-blue-600 hover:bg-blue-700 transition-all px-5 py-2.5 text-white rounded-xl shadow-md shadow-blue-600/25 text-sm">
                <Mail className="w-4 h-4" /> Contact
              </a>
            </li>
          </ul>
        </nav>

        <DropDownBar upSectionRef={upSection} />

        {/* Hero */}
        <div ref={upSection} className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center pb-24">

          {/* Copy */}
          <div className="space-y-8">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
                <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
                Serving {service.title}
              </div>
              <h1 className="font-black text-gray-900 text-5xl lg:text-6xl leading-[1.05] tracking-tight">
                {service.title} <span className="text-blue-600">Plumbing</span>
              </h1>
              <p className="text-gray-500 text-lg leading-relaxed max-w-md">
                {service.description} Contact us today for fast, professional plumbing service in {service.title}.
              </p>
            </div>
            <PrimaryButton />
          </div>

          {/* Map */}
           <div className="relative">
                         {/* Decorative offset frame */}
                         <div aria-hidden="true" className="absolute inset-0 rounded-3xl border-2 border-blue-100 translate-x-3 translate-y-3 -z-10" />
            <iframe
              src={`https://www.google.com/maps?q=${service.coords.lat},${service.coords.lng}&output=embed`}
              className="relative w-full h-96 rounded-2xl shadow-xl border-4 border-white"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title={`${service.title} plumbing service area`}
            />
          </div>
        </div>

      </header>

      <main className="max-w-[90%] mx-auto space-y-26 xl:max-w-6xl">
        <section><ServicesGrid location={service.title} /></section>
        <section><WhyChooseUs /></section>
        <section><Reviews /></section>
        <section><FAQs /></section>
        <section><CTASection /></section>
      </main>

      <footer><Footer /></footer>
    </div>
  );
}